import { ReactiveVar } from '@apollo/client'
import { ColDef, GridApi } from 'ag-grid-community'
import { ContextualMenuItem } from 'ts/types/commonTable.types'
import { bestFitAllColumns } from './bestFitAllColumns'
import { customizeColumns } from './customizeColumns'
import { removeColumn } from './removeColumn'
import { resetToDefault } from './resetToDefault'
import { sortBy } from './sortBy'

export const getHeaderContextMenuItems = (
  rightClickEvent: any,
  gridApi: GridApi,
  closeMenuVar: ReactiveVar<any>,
  columnDefs: ColDef[],
  tableKey: string,
  hideCustomizeColumns = false
): ContextualMenuItem[] => {
  const colId = rightClickEvent?.currentColumn?.getColId()

  const menuItems: ContextualMenuItem[] = [
    bestFitAllColumns(gridApi, closeMenuVar),
    removeColumn(gridApi, colId, closeMenuVar),
    sortBy(gridApi, colId, closeMenuVar),
    resetToDefault(gridApi, closeMenuVar, columnDefs, tableKey),
  ]

  if (!hideCustomizeColumns) {
    menuItems.push(customizeColumns(closeMenuVar))
  }

  return menuItems
}
